import queryString from "query-string";
import { useLocation } from "react-router-dom";

export function useParams() {
  const location = useLocation();
  const params = queryString.parse(location.search);

  return params;
}
